module.exports = __webpack_public_path__ + "static/img/h7.de3567b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h7.jpg
// module id = RXLa
// module chunks = 0